import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SearchRequestComponent } from '@app/layout/search-request/search-request.component';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SearchRequestComponent],
})
export class SearchComponent {
  constructor(private store: Store) {}

  protected fc = new FormControl();

  protected onSearch(value: string | null): void {
    this.store.dispatch(
      new Navigate(['/gallery'], value ? { search: value.trim() } : {}),
    );
  }
}
